<template>
  <div>
    <!-- 轮播图 -->
    <div class="start-swiper" v-if="!isMobile">
      <el-carousel trigger="click" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="item in offcial_website_swiper" :key="item.id">
          <img :src="item.url" width="100%" class="swiperImg" />
        </el-carousel-item>
      </el-carousel>
      <login></login>
    </div>
    <div class="start-swiperBox" v-if="isMobile">
      <el-carousel trigger="click" :height="bannerHeightRem">
        <el-carousel-item v-for="item in itemsOne" :key="item.id">
          <img :src="item.url" width="100%" class="swiperImgBox" />
        </el-carousel-item>
      </el-carousel>
      <!-- <login></login> -->
    </div>

    <div :class="isMobile ? 'dataDisplayBox' : 'dataDisplay'">
      <div :class="isMobile ? 'dataItemBox' : 'dataItem'">
        <div :class="isMobile ? 'firstLevelTitleBox' : 'firstLevelTitle'">
          8年+行业
        </div>
        <div :class="isMobile ? 'secondaryTitleBox' : 'secondaryTitle'">
          深耕沉淀
        </div>
      </div>
      <div :class="isMobile ? 'dataItemBox' : 'dataItem'">
        <div :class="isMobile ? 'firstLevelTitleBox' : 'firstLevelTitle'">
          1.2w+客户
        </div>
        <div :class="isMobile ? 'secondaryTitleBox' : 'secondaryTitle'">
          信任合作
        </div>
      </div>
      <div :class="isMobile ? 'dataItemBox' : 'dataItem'">
        <div :class="isMobile ? 'firstLevelTitleBox' : 'firstLevelTitle'">
          3.4万+SKU
        </div>
        <div :class="isMobile ? 'secondaryTitleBox' : 'secondaryTitle'">
          仓库周转
        </div>
      </div>
      <div :class="isMobile ? 'dataItemBox showBorder' : 'dataItem showBorder'">
        <div :class="isMobile ? 'firstLevelTitleBox' : 'firstLevelTitle'">
          2.3亿+货单
        </div>
        <div :class="isMobile ? 'secondaryTitleBox' : 'secondaryTitle'">
          累计处理
        </div>
      </div>
    </div>

    <ModuleHead title="蜂腾核心服务" englis="FENGTENG CORE SERVICES">
      <div class="coreServices" v-if="!isMobile">
        <div class="clouds">
          <div class="cloudsimg">
            <img src="@/assets/public/蜂腾云端.png" alt="" class="img" />
            <div class="title">蜂腾云端-DMS系统</div>
            <div class="english">DATA MANAGEMENT SYSTEM</div>
            <div class="symbol">+</div>
            <PopUpButton
              title="查看更多"
              class="buttonCenter"
              @click.native="toRouter('/numericalIntelligenceSystem')"
            >
            </PopUpButton>
          </div>
          <div class="cloudsbj">
            <img src="@/assets/public/蜂腾云端.png" alt="" class="img" />
            <div class="title">蜂腾云端-DMS系统</div>
            <div class="english">DATA MANAGEMENT SYSTEM</div>
            <div class="symbol">+</div>
            <div class="introduce">
              DMS系统基于大数据模型计算，AI核心算法，给予最优仓配策略、调配策略、包装方案等，实现大数据独立化运营体系。
            </div>
            <PopUpButton
              title="查看更多"
              class="buttonCenter"
              :displayStatus="false"
              @click.native="toRouter('/numericalIntelligenceSystem')"
            ></PopUpButton>
          </div>
        </div>

        <div class="three fx">
          <div class="cloudWarehouse">
            <div class="cloudWarehouseImg">
              <img src="@/assets/public/智慧云仓.png" alt="" class="img" />
              <div class="title">智慧云仓</div>
              <div class="english">THE CLOUD OF WISDOM</div>

              <PopUpButton
                title="查看更多"
                class="button"
                @click.native="toRouter('/smartCloudWarehouse')"
              ></PopUpButton>
            </div>
            <div class="cloudWarehousebj">
              <img src="@/assets/public/智慧云仓.png" alt="" class="img " />
              <div class="title">智慧云仓</div>
              <div class="english">THE CLOUD OF WISDOM</div>
              <PopUpButton
                title="查看更多"
                class="button"
                :displayStatus="false"
                @click.native="toRouter('/smartCloudWarehouse')"
              ></PopUpButton>
              <div class="introduce">
                通过蜂腾云系统DMS系统加持，全国网点的仓网布局，全栈式解决电商商家的仓储周转问题，利用云仓仓网解决商家从打单-分配-分拣-包装-发货-售后的售后问题，帮助商家提升物流、售后等方面的用户体验
              </div>
            </div>
          </div>
          <div class="cloudWarehouse">
            <div class="digitalLogisticsImg">
              <img src="@/assets/public/智慧物流.png" alt="" class="img img1" />
              <div class="title">数字物流</div>
              <div class="english">SMART LOGISTICS</div>

              <PopUpButton
                title="查看更多"
                class="button"
                @click.native="toRouter('/digitalLogistics')"
              ></PopUpButton>
            </div>
            <div class="cloudWarehousebj">
              <img src="@/assets/public/智慧物流.png" alt="" class="img img1" />
              <div class="title">数字物流</div>
              <div class="english">SMART LOGISTICS</div>
              <PopUpButton
                title="查看更多"
                class="button"
                :displayStatus="false"
                @click.native="toRouter('/digitalLogistics')"
              ></PopUpButton>
              <div class="introduce">
                通过数字化产品构建全链路物流生态，提供端到端服务、数字运力、智能规划、信息透明和智能监控等功能，形成丰富等物流资源和服务场景的全链路体系，为客户提供物流链信息作业的各个环节、营运解决方案、营运作业的平台，以评估、监控及快速回顾运作信息。通过物流标准化的实现，提供给用户零担专车等多种组合的物流平台
              </div>
            </div>
          </div>
          <div class="cloudWarehouse cloneMargin">
            <div class="marketingTradeImg">
              <img src="@/assets/public/采销贸易.png" alt="" class="img img2" />
              <div class="title">采销贸易</div>
              <div class="english">MARKETING TRADE</div>

              <PopUpButton
                title="查看更多"
                class="button"
                @click.native="toRouter('/procurementSalesTrade')"
              ></PopUpButton>
            </div>
            <div class="cloudWarehousebj">
              <img src="@/assets/public/采销贸易.png" alt="" class="img img2" />
              <div class="title">采销贸易</div>
              <div class="english">MARKETING TRADE</div>
              <PopUpButton
                title="查看更多"
                class="button"
                :displayStatus="false"
                @click.native="toRouter('/procurementSalesTrade')"
              ></PopUpButton>
              <div class="introduce">
                通过8年行业沉淀，搭建从产品从源产地，工厂，港口贸易商到经销商，线下终端门店，电商达人直播间等销售渠道的全链路生态货盘，涉及全网数十种品类，7000+sku,打通货物采购-经销-终端-消费者的链路周转，以DMS系统为中台，用数据能力赋予品牌商品在各个渠道中的灵活流转
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="coreServicesBox" v-else>
        <div class="cloudsBox">
          <div class="cloudsimgBox">
            <img src="@/assets/public/蜂腾云端.png" alt="" class="imgBox" />
            <div class="titleBox">蜂腾云端-DMS系统</div>
            <div class="englishBox">DATA MANAGEMENT SYSTEM</div>
            <div class="symbolBox">+</div>
            <div class="introduceBox">
              DMS系统基于大数据模型计算，AI核心算法，给予最优仓配策略、调配策略、包装方案等，实现大数据独立化运营体系。
            </div>
            <PopUpButton
              title="查看更多"
              class="buttonCenter"
              @click.native="toRouter('/numericalIntelligenceSystem')"
            >
            </PopUpButton>
          </div>
        </div>

        <div class="threeBox fx">
          <div class="cloudWarehouseBox">
            <div class="cloudWarehouseImgBox">
              <img src="@/assets/public/智慧云仓.png" alt="" class="imgBox" />
              <div class="titleBox">智慧云仓</div>
              <div class="englishBox">THE CLOUD OF WISDOM</div>
              <div class="symbolBox">+</div>
            </div>
            <div class="introduceBox">
              通过蜂腾云系统DMS系统加持，全国网点的仓网布局，全栈式解决电商商家的仓储周转问题，利用云仓仓网解决商家从打单-分配-分拣-包装-发货-售后的售后问题，帮助商家提升物流、售后等方面的用户体验
            </div>
            <PopUpButton
              title="查看更多"
              class="buttonBox"
              :displayStatus="false"
              @click.native="toRouter('/smartCloudWarehouse')"
            ></PopUpButton>
          </div>
          <div class="cloudWarehouseBox">
            <div class="digitalLogisticsImgBox">
              <img src="@/assets/public/智慧物流.png" alt="" class="imgBox" />
              <div class="titleBox">数字物流</div>
              <div class="englishBox">SMART LOGISTICS</div>
              <div class="symbolBox">+</div>
            </div>
            <div class="introduceBox">
              以数字化产品构建全链路物流生态，具备端到端服务、数字运力、智能规划等功能，形成全链路体系，为客户提供物流链各环节作业平台及营运解决方案，实现物流标准化，提供零担专车等多种组合物流平台，供用户评估、监控及快速回顾运作信息。
            </div>
            <PopUpButton
              title="查看更多"
              :displayStatus="false"
              class="buttonBox"
              @click.native="toRouter('/digitalLogistics')"
            ></PopUpButton>
          </div>
          <div class="cloudWarehouseBox">
            <div class="marketingTradeImgBox">
              <img src="@/assets/public/采销贸易.png" alt="" class="imgBox" />
              <div class="titleBox">采销贸易</div>
              <div class="englishBox">MARKETING TRADE</div>
              <div class="symbolBox">+</div>
            </div>
            <div class="introduceBox">
              8
              年行业沉淀，构建全链路生态货盘。连接源产地、工厂、贸易商等至经销商、门店及直播间，涵盖数十品类、7000+sku。打通采购、经销至消费者的链路周转，以
              DMS 系统为中台，凭借数据能力让品牌商品在各渠道灵活流转。
            </div>
            <PopUpButton
              title="查看更多"
              class="buttonBox"
              :displayStatus="false"
              @click.native="toRouter('/procurementSalesTrade')"
            ></PopUpButton>
          </div>
        </div>
      </div>
    </ModuleHead>

    <ModuleHead title="蜂腾资讯" englis="FENGTENG INFORMATION">
      <div class="prefabrication" v-if="!isMobile">
        <div
          :style="
            activeIndex === index
              ? 'background-color: #fe5e00;color: white;'
              : 'color: #8c8c8c;border: 1px solid #e6e6e6;'
          "
          class="one"
          v-for="(item, index) in allData"
          :key="index"
          @click="setActive(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="prefabricationBox" v-if="isMobile">
        <div
          :style="
            activeIndex === index
              ? 'color: #fe5e00;'
              : 'color: #070707;font-weight: 400;'
          "
          class="oneBox"
          v-for="(item, index) in allData"
          :key="index"
          @click="setActive(index)"
        >
          {{ item }}
          <div
            :style="
              activeIndex === index ? ' display: block;' : ' display: none;'
            "
            class="barBox"
          ></div>
        </div>
      </div>
      <div class="subject" v-if="!isMobile">
        <div class="one">
          <el-carousel
            :height="subjectHeight + 'px'"
            arrow="never"
            :interval="2000"
          >
            <el-carousel-item v-for="(item, index) in dynamicList" :key="index">
              <img :src="item.coverImg" style="width: 100%; height: 100%" />
              <div class="listOne">
                <div class="boxOne">{{ item.prefix }}</div>
                <div class="boxTwo">{{ item.shortPublishTime }}</div>
              </div>
              <div class="title">{{ item.title }}</div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="two">
          <div
            class="list"
            :class="{ active: index === hoverIndex }"
            @mouseenter="hoverIndex = index"
            @mouseleave="hoverIndex = 0"
            v-for="(item, index) in dynamicList"
            :key="index"
            @click="dynamicClick(item, allUpdatesList)"
          >
            <div class="listOne">
              <div class="boxOne">{{ item.prefix }}</div>
              <div class="boxTwo">{{ item.shortPublishTime }}</div>
            </div>

            <div class="listTwo">
              <div class="title">{{ item.title }}</div>
              <div class="titleBox">
                {{ item.subtitle }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="subjectBox" v-if="isMobile">
        <div
          class="listBox"
          v-for="(item, index) in dynamicList"
          :key="index"
          @click="dynamicClick(item, allUpdatesList)"
        >
          <div class="listOneBox">
            <img :src="item.coverImg" class="imgBox" />
            <div class="listBoxOne">
              <div class="boxOneBox">{{ item.prefix }}</div>
              <div class="boxTwoBox">{{ item.shortPublishTime }}</div>
            </div>
          </div>

          <div class="listTwoBox">
            <div class="titleBox">{{ item.title }}</div>
            <div class="titleBox1">
              {{ item.subtitle }}
            </div>
          </div>
        </div>
      </div>
      <div class="oneTextFour point" @click="viewMore" v-if="!isMobile">
        <div class="oneSpan">查看更多</div>
        <div class="twoSpan"></div>
        <div class="threeSpan"></div>
      </div>
      <PopUpButton
        v-if="isMobile"
        title="查看更多"
        class="oneTextFourBox"
        @click.native="viewMore"
      ></PopUpButton>
    </ModuleHead>
    <img
      src="@/assets/public/底部联系我们2.jpg"
      alt=""
      style="width: 100%; display: block; cursor: pointer"
      @click="$refs.Collaborate.inio()"
      v-if="!isMobile"
    />
    <Collaborate ref="Collaborate" :source="false"></Collaborate>
  </div>
</template>

<script>
import login from "./components/login.vue";

export default {
  components: { login },
  data() {
    return {
      itemsOne:[],
      allUpdatesList: [],
      subjectHeight: 0,
      publishType: 0,
      dynamicList: [],
      hoverIndex: 0,
      bannerHeight: 0,
      activeIndex: 0,
      allData: ["全部", "公司动态", "行业新闻"],
      offcial_website_swiper: [],
      initializationHeight: 0,
    };
  },
    computed: {
    bannerHeightRem() {
      return `4.34rem`;
    }
  },
  mounted() {
    // this.initBannerHeight();
    this.getDynamic();
    this.getSwiper();
     this.getSwiperOne();
    this.screenWidth = window.innerWidth;
    this.subjectHeight = Math.trunc((420 / 1920) * this.screenWidth);
    this.screenWidth1 = window.innerWidth;
    this.bannerHeight = Math.trunc((936 / 1920) * this.screenWidth1);
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.subjectHeight = Math.trunc((420 / 1920) * this.screenWidth);
      this.screenWidth1 = window.innerWidth;
      this.bannerHeight = Math.trunc((936 / 1920) * this.screenWidth1);
    };

    // window.onresize = () => {
    //     this.bannerHeight =
    //       window.innerHeight ||
    //       document.documentElement.clientHeight ||
    //       document.body.clientHeight;
    //   };
  },
  methods: {
    async getSwiper() {
      let res = await this.$http.get(
        "https://dmsapi.fengtengjituan.cn/prod-api/system/cate/file/list/by-cate?cate=offcial_website_swiper"
        // "http://192.168.110.89:8080/system/cate/file/list/by-cate?cate=offcial_website_swiper"
      );
      if (res.data.data) {
        this.offcial_website_swiper = res.data.data;
      }
    },
     async getSwiperOne() {
      let res = await this.$http.get(
        " https://dmsapi.fengtengjituan.cn/prod-api/system/cate/file/list/by-cate?cate=app_offcial_website_swiper"
        // "http://192.168.110.232:8080/system/cate/file/list/by-cate?cate=app_offcial_website_swiper"
      );
      if (res.data.data) {
        this.itemsOne = res.data.data;
      }
    },
    toRouter(route) {
      this.$router.push(route);
    },
    async dynamicClick(e, a) {
      const dataStr = JSON.stringify(e);
      const otherDataStr = JSON.stringify(a);
      this.$router.push({
        path: "/realTimeEdit",
        query: {
          warehouseInfo: dataStr,
          someOtherData: otherDataStr,
        },
      });
      const id = e.id;
      await this.$http.post(
        `https://dmsapi.fengtengjituan.cn/prod-api/system/official/publish/center/addPopularityNum/${id}`
        // `http://192.168.110.89:8080/system/official/publish/center/addPopularityNum/${id}`
      );
    },
    async getDynamic() {
      let res = await this.$http.get(
        // "http://192.168.110.89:8080/system/official/publish/center/home/list?publishType="
        "https://dmsapi.fengtengjituan.cn/prod-api/system/official/publish/center/home/list?publishType=" +
          this.publishType
      );
      if (res.data.data) {
        this.allUpdatesList = res.data.data;
        this.dynamicList = res.data.data.slice(0, 3).map((item, index) => {
          const prefix = index + 1;
          item.prefix = `0${prefix}`.padStart(2, "0");
          return item;
        });
      }
    },
    viewMore() {
      this.$router.push({ path: "/realTimeInfo" });
    },
    handleMouseEnter(index) {
      this.hoverIndex = index;
    },
    handleMouseLeave() {
      this.hoverIndex = 0;
    },
    setActive(index) {
      this.activeIndex = index;
      if (index == 0) {
        this.publishType = 0;
        this.getDynamic();
      } else if (index == 1) {
        this.publishType = 20;
        this.getDynamic();
      } else if (index == 2) {
        this.publishType = 40;
        this.getDynamic();
      }
    },
    /* 初始化首屏轮播图高度 */
    // initBannerHeight() {
    //   this.bannerHeight =
    //     window.innerHeight ||
    //     document.documentElement.clientHeight ||
    //     document.body.clientHeight;

    // },
  },
};
</script>

<style lang="scss" scoped>
.start-swiper {
  margin-top: 59px;
  width: 100%;

  .swiperImg {
    height: 100%;
    background-size: 100% 100%;
  }
}

.start-swiperBox {
  width: 100%;

  .swiperImgBox {
    height: 100%;
    background-size: 100% 100%;
  }
}

.dataDisplay {
  height: 186px;
  display: flex;
  align-items: center;
  text-align: center;

  .dataItem {
    width: 25%;
    border-right: 2px solid #000;
  }

  .showBorder {
    border: none;
  }

  .firstLevelTitle {
    color: #fe5e00;
    font-size: 47px;
    margin-bottom: 10px;
    font-weight: 900;
  }

  .secondaryTitle {
    font-size: 18px;
  }
}

.dataDisplayBox {
  height: 0.85rem;
  display: flex;
  align-items: center;
  text-align: center;

  .dataItemBox {
    width: 25%;
    border-right: 0.01rem solid #000;
  }

  .showBorder {
    border: none;
  }

  .firstLevelTitleBox {
    color: #fe5e00;
    font-size: 0.25rem;
    margin-bottom: 0.08rem;
    font-weight: bold;
  }

  .secondaryTitleBox {
    font-size: 0.11rem;
  }
}

.coreServices {
  .clouds {
    position: relative;
    margin-bottom: 10px;
    height: 445px;
    text-align: center;

    .cloudsimg {
      width: 100%;
      height: 100%;
      background: url("@/assets/public/蜂腾云端底图.png") no-repeat;
      background-size: 100% 100%;

      position: relative;
    }

    .cloudsbj {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fe5e00;
      opacity: 0;
      z-index: 10;
    }

    .cloudsbj:hover {
      opacity: 1;
      transition: all 1s;
    }

    .img {
      margin-top: 53px;
      width: 70px;
      height: 58px;
    }

    .title {
      width: 267px;
      height: 29px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 30px;
      color: #f6f6f6;
      margin: 16px auto 14px;
    }

    .english {
      width: 204px;
      height: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 14px;
      color: #f6f6f6;
      margin: 0px auto 39px;
    }

    .symbol {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 43px;
      color: #f6f6f6;
      margin: 0px auto 36px;
      text-align: center;
    }

    .introduce {
      width: 995px;
      height: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 18px;
      color: #f6f6f6;
      margin: 0 auto 10px;
    }

    .buttonCenter {
      display: flex;
      justify-content: center;
    }
  }

  .three {
    // background: pink;
    justify-content: space-between;

    .cloudWarehouse {
      position: relative;
      margin-right: 10px;
      // float: left;
      width: 32.98%;
      

      .cloudWarehouseImg {
        width: 100%;
        height: 425px;
        background: url("@/assets/public/智慧云仓底图.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
      }

      .digitalLogisticsImg {
        width: 100%;
        height: 425px;
        background: url("@/assets/public/智慧物流底图.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
      }

      .marketingTradeImg {
        width: 100%;
        height: 425px;
        background: url("@/assets/public/采销贸易底图.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
      }

      .cloudWarehouseImg {
        width: 100%;
        height: 425px;
        background: url("@/assets/public/智慧云仓底图.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
      }

      .cloudWarehousebj {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 425px;
        background: #fe5e00;
        opacity: 0;
        z-index: 10;
      }

      .cloudWarehousebj:hover {
        opacity: 1;
        transition: all 1s;
      }

      .cloudWarehousebj {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 425px;
        background: #fe5e00;
        opacity: 0;
        z-index: 10;
      }

      .cloudWarehousebj:hover {
        opacity: 1;
        transition: all 1s;
      }

      .img {
        display: block;
        margin: 35px 0 0 54px;
        width: 54px;
        height: 54px;
      
      }
      .img1{
         margin: 35px 0 0 52px;
         width: 78px;
        height: 48px;
      }
       .img2{
         margin: 31px 0 0 52px;
         width: 62px;
        height: 62px;
      }

      .title {
        width: 115px;
        height: 27px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 28px;
        color: #f6f6f6;
        margin: 26px 0 0 54px;
      }

      .english {
        width: 147px;
        height: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 12px;
        color: #f6f6f6;
        margin: 15px 0 20px 54px;
      }

      .symbol {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 42px;
        color: #f6f6f6;
        margin: 38px 0 0 54px;
      }

      .introduce {
        // width: 544px;
        // height: 45px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #f6f6f6;
        margin: 32px 54px 0 54px;
        line-height: 20px;
      }

      .button {
        margin: 50px 0 0 54px;
      }
    }
  }
}

.coreServicesBox {
  .cloudsBox {
    position: relative;
    margin-bottom: 0.05rem;
    height: 3.98rem;
    text-align: center;

    .cloudsimgBox {
      width: 100%;
      height: 100%;
      background: url("@/assets/public/蜂腾云端底图1.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .imgBox {
        width: 0.71rem;
        height: 0.57rem;
        margin-top: 0.23rem;
      }
      .titleBox {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 0.28rem;
        color: #f6f6f6;
        margin: 0.23rem auto 0.18rem;
      }

      .englishBox {
        font-weight: 500;
        font-size: 0.11rem;
        color: #f6f6f6;
        margin: 0px auto 0.1rem;
      }

      .symbolBox {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 0.45rem;
        color: #f6f6f6;
        margin: 0px auto 0.05rem;
        text-align: center;
      }
      .introduceBox {
        width: 6.5rem;
        height: 0.55rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 0.22rem;
        color: #ffffff;
        line-height: 0.35rem;
        margin: 0 auto 0.37rem;
      }

      .buttonCenter {
        display: flex;
        justify-content: center;
      }
    }
  }

  .threeBox {
    justify-content: space-between;

    .cloudWarehouseBox {
      position: relative;
      margin-right: 0.04rem;
      width: 32.98%;
      height: 5rem;
      background-color: #fe5e00;

      .cloudWarehouseImgBox,
      .digitalLogisticsImgBox,
      .marketingTradeImgBox {
        width: 100%;
        height: 1.52rem;
        background: url("@/assets/public/智慧云仓底图1.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .imgBox {
          display: block;
          width: 0.36rem;
          height: 0.36rem;
          margin: 0.24rem 0 0.08rem 0.21rem;
        }
        .titleBox {
          font-weight: 500;
          font-size: 0.19rem;
          color: #f6f6f6;
          margin: 0 0 0 0.21rem;
        }
        .englishBox {
          font-weight: 500;
          font-size: 0.08rem;
          color: #f6f6f6;
          margin: 0.06rem 0 0 0.22rem;
        }
        .symbolBox {
          font-weight: 500;
          font-size: 0.28rem;
          color: #f6f6f6;
          margin-left: 0.24rem;
        }
      }
      .introduceBox {
        opacity: 0.9;
        width: 2rem;
        height: 1.91rem;
        font-weight: 400;
        font-size: 0.16rem;
        color: #f6f6f6;
        margin: 0.22rem 0 0 0.22rem;
        line-height: 0.23rem;
      }

      .buttonBox {
        margin: 0.68rem 0 0 0.25rem;
      }

      .digitalLogisticsImgBox {
        width: 100%;
        height: 1.52rem;
        background: url("@/assets/public/智慧物流底图1.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .imgBox {
          display: block;
          width: 0.53rem;
          height: 0.33rem;
          margin: 0.22rem 0 0.11rem 0.21rem;
        }
      }

      .marketingTradeImgBox {
        width: 100%;
        height: 1.52rem;
        background: url("@/assets/public/采销贸易底图1.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .imgBox {
          display: block;
          width: 0.4rem;
          height: 0.4rem;
          margin: 0.18rem 0 0.1rem 0.2rem;
        }
      }
    }
  }
}

.cloneMargin {
  margin: 0 !important;
}

.prefabrication {
  width: 400px;
  height: 50px;
  margin: 50px auto 45px auto;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .one {
    width: 102px;
    height: 31px;
    border: 1px solid #e6e6e6;
    font-weight: 300;
    font-size: 16px;
    color: #8c8c8c;
    line-height: 31px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
  }
}

.prefabricationBox {
  width: 100%;
  height: 0.5rem;
  margin: 0.5rem auto 0.35rem auto;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .oneBox {
    width: 1.5rem;
    font-weight: bold;
    font-size: 0.26rem;
    color: #fe5e00;
    text-align: center;
    transition: background-color 0.3s, color 0.3s;
    position: relative;
    .barBox {
      position: absolute;
      top: 0.43rem;
      left: 0.45rem;
      width: 0.59rem;
      height: 0.05rem;
      background: #ff5d00;
    }
  }
}

.subject {
  width: 1340px;
  height: 420px;
  // padding: 0 0 0 14.58vw;
  display: flex;
  margin: auto;

  .one {
    // width: 33.51vw;
    width: 644px;
    height: 100%;
    margin-right: 48px;
    position: relative;

    .listOne {
      position: absolute;
      top: 0;
      left: 0;
      width: 97px;
      height: 96px;
      background-color: #fe5e00;
      margin-right: 15px;
      transition: all 0.3s ease;

      .boxOne {
        font-weight: bold;
        font-size: 45px;
        color: #ffffff;
        margin: 15px 0 6px 20px;
      }

      .boxTwo {
        font-family: Microsoft YaHei;
        font-weight: 300;
        font-size: 16px;
        color: #ffffff;
        margin-left: 15px;
      }
    }

    .title {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 60px;
      font-weight: 400;
      font-size: 18px;
      color: #fff;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.3);
      padding: 10px 10px 0 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .two {
    // width: 33.65vw;
    width: 645px;
    height: 100%;

    .list {
      width: 100%;
      height: 96px;
      display: flex;
      margin-bottom: 20px;
      transition: all 0.3s ease;
      cursor: pointer;

      .listOne {
        width: 97px;
        height: 96px;
        background-color: #ffd1b6;
        margin-right: 15px;
        transition: all 0.3s ease;

        .boxOne {
          font-weight: bold;
          font-size: 45px;
          color: #ffffff;
          margin: 15px 0 6px 20px;
        }

        .boxTwo {
          font-family: Microsoft YaHei;
          font-weight: 300;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
        }
      }

      .listTwo {
        width: 25.62vw;

        .title {
          width: 20vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #282828;
          margin-bottom: 16px;
          transition: all 0.3s ease;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .titleBox {
          font-family: Microsoft YaHei;
          font-weight: 300;
          font-size: 16px;
          color: #8a8a8a;
          line-height: 30px;
          overflow: hidden;
          height: 55px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }

    .active {
      // width: 33.56vw;
      width: 645px;
      height: 154px;
      background: #ffffff;
      box-shadow: 0px 3px 29px 0px rgba(0, 0, 0, 0.35);
      padding: 30px 13px 0 25px;

      .listOne {
        background-color: #fe5e00;
      }

      .listTwo .title {
        color: #fe5e00;
      }
    }
  }
}

.subjectBox {
  width: 6.83rem;
  margin: auto;
  .listBox {
    width: 100%;
    height: 2.05rem;
    display: flex;
    padding-top: 0.3rem;
    border-bottom: 0.01rem solid #e6e6e6;
    .listOneBox {
      position: relative;
      margin-right: 0.17rem;
      .imgBox {
        width: 2.34rem;
        height: 1.53rem;
      }
      .listBoxOne {
        position: absolute;
        top: 0;
        left: 0;
        width: 0.36rem;
        height: 0.35rem;
        background-color: #fe5e00;

        .boxOneBox {
          font-weight: bold;
          font-size: 0.16rem;
          color: #ffffff;
          margin: 0.08rem 0 0.02rem 0.08rem;
        }

        .boxTwoBox {
          font-weight: 300;
          font-size: 0.06rem;
          color: #ffffff;
          margin-left: 0.07rem;
        }
      }
    }
    .listTwoBox {
      width: 4.3rem;
      .titleBox {
        width: 100%;
        font-weight: bold;
        color: #070707;
        font-size: 0.25rem;
        margin-bottom: 0.1rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .titleBox1 {
        font-weight: 300;
        font-size: 0.22rem;
        color: #6d6d6d;
        line-height: 0.33rem;
        overflow: hidden;
        height: 1rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }
    }
  }

  .active {
    // width: 33.56vw;
    width: 645px;
    height: 154px;
    background: #ffffff;
    box-shadow: 0px 3px 29px 0px rgba(0, 0, 0, 0.35);
    padding: 30px 13px 0 25px;

    .listOne {
      background-color: #fe5e00;
    }

    .listTwo .title {
      color: #fe5e00;
    }
  }
}

.oneTextFour {
  margin: 60px auto 120px auto;
  position: relative;
  width: 150px;
  height: 40px;
  border-radius: 3px;
  border: 1px solid #e6e6e6;

  .oneSpan {
    position: absolute;
    top: 10px;
    left: 25px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #aaaaaa;
  }

  .twoSpan {
    position: absolute;
    top: 20px;
    left: 105px;
    width: 24px;
    height: 1px;
    background-color: #aaaaaa;
  }

  .threeSpan {
    position: absolute;
    top: 15px;
    left: 118px;
    width: 11px;
    height: 11px;
    border-right: 1px solid #aaaaaa;
    border-bottom: 1px solid #aaaaaa;
    transform: rotate(-45deg);
  }
}
.oneTextFourBox{
  margin:0.3rem auto;
}


.point {
  cursor: pointer;
}

::v-deep .el-carousel__indicators--horizontal {
  display: none;
}
</style>
